import { gql } from '@apollo/client';
import {
  PROJECT_CONTRIBUTOR_FRAGMENT,
  ASSET_FEED_ITEM_FRAGMENT,
  ASSET_FEED_ITEM_PHOTO_FRAGMENT,
  ASSET_FEED_ITEM_VIDEO_FRAGMENT,
} from '../../gql/fragments.graphql';

export default gql`
  query GetPhoto($id: ID!) {
    node(id: $id) {
      ... on AssetFeedItem {
        ...AssetFeedItemFragment
      }

      ... on RecordableInterface {
        commentsCount
        voiceNotesCount
        tagsCount
      }

      ... on Photo {
        ...AssetFeedItemPhotoFragment
      }
      ... on Video {
        ...AssetFeedItemVideoFragment
      }
    }
  }

  ${ASSET_FEED_ITEM_FRAGMENT}
  ${PROJECT_CONTRIBUTOR_FRAGMENT}
  ${ASSET_FEED_ITEM_PHOTO_FRAGMENT}
  ${ASSET_FEED_ITEM_VIDEO_FRAGMENT}
`;
